const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
]

/**
 * Formats an ISO date (YYYY-MM-DD) as "July 18, 2026".
 * Parsed by hand rather than with Date so the server and the browser
 * always render exactly the same string.
 */
export const formatDate = (iso: string): string => {
    const [year, month, day] = iso.slice(0, 10).split('-')
    const monthName = MONTHS[Number(month) - 1]

    if (!monthName || !year || !day) {
        return iso
    }

    return `${monthName} ${Number(day)}, ${year}`
}
